// extracted by mini-css-extract-plugin
export default {"spinner_clip":"clipSpinner_spinner_clip__is3Sn"};